// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"_n-z","breadcrumbForward":"ao-z","breadcrumbBack":"bo-z","selected":"co-z"};